import { basicConfig } from './basic';

export const materialUIConfig = {
    ...basicConfig,
    name: 'materialUiForm',
};



// WEBPACK FOOTER //
// ./src/app/redux/configs/material-ui.js